export default {"src":"/_next/static/media/step-one.515b4489.gif","height":976,"width":832};